import { MaskInputOptions } from 'maska';

import { isStartOfIban, isStartOfYapealIban } from '@/utils/formats';

export function _generateIBANMask(iban: string): string {
  const baseMask = 'AA## ';
  const digits = iban.slice(4); // Exclude the country code and checksum
  let mask = baseMask;
  let groupSize = 4;

  for (let i = 0; i < digits.length; i += groupSize) {
    if (i + groupSize > digits.length) {
      groupSize = digits.length - i; // Adjust the group size for remaining digits
    }
    mask += 'X'.repeat(groupSize) + ' ';
  }

  return mask.trim();
}

export const IbanMaskOptions: MaskInputOptions = {
  mask: (value: string) => (isStartOfYapealIban(value) ? 'AA## ##### XXXXXXXXXXXX' : _generateIBANMask(value)),
  tokens: {
    A: {
      pattern: /[A-Z]/,
      transform: (chr: string) => chr.toUpperCase()
    },
    X: {
      pattern: /[A-Z]|[0-9]/,
      transform: (chr: string) => chr.toUpperCase()
    }
  }
};

export const IbanOptionalMaskOptions: MaskInputOptions = {
  mask: (value: string) =>
    isStartOfIban(value) ? (isStartOfYapealIban(value) ? 'AA## ##### XXXXXXXXXXXX' : _generateIBANMask(value)) : '?',
  tokens: {
    A: {
      pattern: /[A-Z]/,
      transform: (chr: string) => chr.toUpperCase()
    },
    X: {
      pattern: /[A-Z]|[0-9]/,
      transform: (chr: string) => chr.toUpperCase()
    },
    '?': {
      pattern: /.*/,
      multiple: true
    }
  }
};

export const SwiftCodeMaskOptions: MaskInputOptions = {
  mask: (value: string) => 'AAAAAAXXXXX',
  tokens: {
    A: {
      pattern: /[A-Z]/,
      transform: (chr: string) => chr.toUpperCase()
    },
    X: {
      pattern: /[A-Z]|[0-9]/,
      transform: (chr: string) => chr.toUpperCase()
    }
  }
};

export const BbanToUpperCaseOptions: MaskInputOptions = {
  mask: (value: string) => 'XXXXXXXXXXXX',
  tokens: {
    X: {
      pattern: /[A-Z]|[0-9]/,
      transform: (chr: string) => chr.toUpperCase()
    }
  }
};

export const generateLimittedUppercaseMaskOptions = (maxChar: number): MaskInputOptions => ({
  mask: 'X'.repeat(maxChar),
  tokens: {
    X: {
      pattern: /[A-Z0-9\-\ ]/,
      transform: (chr: string) => chr.toUpperCase()
    }
  }
});

export const generatePhoneNumberMaskOptionsForCountryCode = (countryCode: string): MaskInputOptions => ({
  mask: (value: string) => {
    switch (countryCode) {
      case '+41': // "CHE"
        return '## ### ## ##';
      case '+43': // "AUT"
        return '### #######';
      case '+33': // "FRA"
        return '# ## ## ## ##';
      case '+49': // "DEU"
        return '### #######';
      case '+39': // "ITA"
        return '### #### ###';
      default:
        return '#'.repeat(value.length + 1);
    }
  },
  tokens: {
    '#': {
      pattern: /[0-9]/,
      transform: (chr: string) => chr
    }
  }
});
